import { createFileRoute } from "@tanstack/react-router";
import { AgentsPage } from "@/components/agents/agents-page";
import { OwnerWorkspaceGate } from "@/components/owner-workspace-gate";
import { PageColumn, PageShell } from "@/components/ui/page-shell";
import { useWorkspaceRoot } from "@/lib/api";

/**
 * Agents: the workspace's agents — managed ones Lobu runs, plus the external
 * agents that connect to it as MCP clients. The managed roster used to live
 * inline in the sidebar; it moved here when Agents became a nav section, and
 * this page is also where the old connectors "Agents" inventory filter landed.
 */
export const Route = createFileRoute("/$owner/agents/")({
	loader: ({ context: { queryClient }, params }) => {
		void queryClient.prefetchQuery(
			useWorkspaceRoot.queryOptions(params.owner, { slug: params.owner }),
		);
	},
	component: AgentsIndexPage,
});

function AgentsIndexPage() {
	const { owner } = Route.useParams();

	return (
		<PageShell className="gap-3 pt-2.5 pb-8">
			<div className="flex min-h-0 min-w-0 flex-1 flex-col">
				<OwnerWorkspaceGate owner={owner}>
					{(props) => (
						<PageColumn className="flex min-h-0 min-w-0 flex-1 flex-col">
							<AgentsPage
								owner={props.ownerSlug}
								isWorkspaceLoading={props.isWorkspaceLoading}
							/>
						</PageColumn>
					)}
				</OwnerWorkspaceGate>
			</div>
		</PageShell>
	);
}
